<div class="brand-reviews">
  <div class="container">
    <h3>Marka Yorumları</h3>

    <!-- Owl Carousel for mobile (< 991px) -->
    <owl-carousel-o [options]="sliderOptions">
      <ng-container *ngFor="let item of reviews">
        <ng-template carouselSlide [id]="item._id">
          <div class="slider-item">
            <div class="slider-item--image">
              <img
                src="/assets/images/customer-reviews/{{ item.image }}"
                [alt]="item.title"
              />
            </div>

            <div class="slider-item--title">
              {{ item.title }}
            </div>

            <div class="slider-item--content">
              {{ item.content }}
            </div>
          </div>
        </ng-template>
      </ng-container>
    </owl-carousel-o>
  </div>
</div>
